import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {AllEntitlements} from './all-entitlements/all-entitlements';
import {CreateGrant} from './create-grant';
import {CreatePreset} from './create-preset';
import {CreateResource} from './create-resource';
import {CreateRole} from './create-role';
import {EditGrant} from './edit-grant';
import {EditPreset} from './edit-preset';
import {EditRole} from './edit-role';
import {UpdateResource} from './update-resource';

export const ManageEntitlementsRouter = () => {
    return (
        <Routes>
            <Route path="/*" element={<AllEntitlements/>}/>
            <Route path="/create-role" element={<CreateRole/>}/>
            <Route path="/role/:roleId" element={<EditRole/>}/>

            <Route path="/create-grant" element={<CreateGrant/>}/>
            <Route path="/grant/:grantId" element={<EditGrant/>}/>

            <Route path="/create-resource" element={<CreateResource/>}/>
            <Route path="/resource/:resourceId" element={<UpdateResource/>}/>

            <Route path="/create-preset" element={<CreatePreset/>}/>
            <Route path="/preset/:presetId" element={<EditPreset/>}/>

            <Route path="*" element={<Navigate to="/entitlements"/>}/>
        </Routes>
    );
};
